import React from 'react';
import { Modal } from 'antd-mobile';



class HintModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible,
        };
    }
    componentDidMount() {

    }
    componentWillReceiveProps(nextProps) {
        // if ((nextProps.visible && this.state.visible != nextProps.visible)) {
        //     this.setState({
        //         visible:nextProps.visible
        //     })
        // }
        
    }
    onClose = () => {
        this.setState({
            visible: false
        })
    }


    render() {

        return (
            <Modal
                visible={this.state.visible}
                transparent
                maskClosable={true}
                onClose={() => this.onClose()}
                footer={[]}
            >
                <div style={{ textAlign: 'center' }}>
                    <div onClick={()=>window.location.href='https://www.kancloud.cn/seven_qdj/qdj_help_201808/737970'}>
                        <div style={{ color: '#39C5C1', fontSize: 16 }}>签到家-基础版（测试）</div>
                        <p style={{ color: '#959595', fontSize: 15, margin: '5px 0' }}>会员可去除本页面</p>
                    </div>
                    <img style={{ width: 200 }} src="https://img.qdj8.cn/qdj8-qrcode.png" alt="" />
                    <p style={{ color: '#959595', fontSize: 15, margin: '5px 0' }}>扫码关注签到家</p>
                    <p style={{ color: '#959595', fontSize: 14 }}>
                        技术支持：
                        <a href="http://www.checkinmaster.com">
                            www.qdj8.cn
                        </a>
                    </p>
                    {/*<a><Icon type={'cross'} /></a>*/}
                </div>
            </Modal>
        )
    }
}




export default HintModal;



// WEBPACK FOOTER //
// ./src/containers/invitation-page/HintModal.jsx